import numeral from 'numeral';
import { Line } from 'rc-progress';
import { Component } from 'react';
import { isTrue } from '../../helpers/isTrue';
import { getDaysOfMonth } from '../../helpers/getDataRange';
import { getastMonthCharges } from './query';
import { withTranslation } from 'react-i18next';

function calculateAddition(percentage) {
    if (percentage < 1) percentage = 1;
    if (percentage > 100) percentage = 100;

    return ((100 - percentage) * 4) / 99;
}

class AdditionalCharges extends Component {
    constructor(props) {
        super();

        this.isSuggestToChangePlan = this.isSuggestToChangePlan.bind(this);

        this.plan_monthly_discover_pages = Number(props.plan_monthly_discover_pages);
        this.plan_monthly_search_records = Number(props.plan_monthly_search_records);
        this.used_monthly_discover_pages = Number(props.used_monthly_discover_pages);
        this.used_monthly_search_records = Number(props.used_monthly_search_records);

        this.last_month_search_records = Number(props.last_month_search_records);
        this.last_month_search_extra = Number(props.last_month_search_extra);
        this.last_month_discover_records = Number(props.last_month_discover_records);
        this.last_month_discover_extra = Number(props.last_month_discover_extra);

        this.isUsageHigher = this.isUsageHigher.bind(this);
        this.basicPlans = ['Basic', 'Trial_Basic'];

        this.state = {
            additionalChargesDiscover: null,
            additionalChargesSearch: null,
        };
    }

    async componentDidMount() {
        try {
            const response = await getastMonthCharges(this.props.csrf_token);
            const data = await response.json();
            const discover = data?.result.find((x) => x.collected_type === 'discover');
            const search = data?.result.find((x) => x.collected_type === 'search');

            this.setState({
                additionalChargesDiscover: discover,
                additionalChargesSearch: search,
            });
        } catch (err) {
            console.log(err);
        }
    }

    isUsageHigher(type) {
        switch (type) {
            case 'discover':
                return this.used_monthly_discover_pages > this.plan_monthly_discover_pages;
            case 'search':
                return this.used_monthly_search_records > this.plan_monthly_search_records;
            default:
                return false;
        }
    }

    isSuggestToChangePlan(discoverMonthlyEstimation, searchMonthlyEstimation) {
        if (
            this.used_monthly_discover_pages > this.plan_monthly_discover_pages ||
            this.used_monthly_search_records > this.plan_monthly_search_records ||
            discoverMonthlyEstimation > this.plan_monthly_discover_pages ||
            searchMonthlyEstimation > this.plan_monthly_search_records
        )
            return true;
        return false;
    }

    render() {
        const { t } = this.props;

        const fisrtLinePercent =
            this.plan_monthly_discover_pages >= this.used_monthly_discover_pages
                ? {
                      percent:
                          (this.used_monthly_discover_pages / this.plan_monthly_discover_pages) *
                          100,
                      exceeded: false,
                  }
                : {
                      percent:
                          (this.plan_monthly_discover_pages / this.used_monthly_discover_pages) *
                          100,
                      exceeded: true,
                  };

        const searchLinePercent =
            this.plan_monthly_search_records > this.used_monthly_search_records
                ? {
                      percent:
                          (this.used_monthly_search_records / this.plan_monthly_search_records) *
                          100,
                      exceeded: false,
                  }
                : {
                      percent:
                          (this.plan_monthly_search_records / this.used_monthly_search_records) *
                          100,
                      exceeded: true,
                  };

        const lastMonthFisrtLinePercent =
            this.plan_monthly_discover_pages > this.last_month_discover_records
                ? {
                      percent:
                          (this.last_month_discover_records / this.plan_monthly_discover_pages) *
                          100,
                      exceeded: false,
                  }
                : {
                      percent:
                          (this.plan_monthly_discover_pages / this.last_month_discover_records) *
                          100,
                      exceeded: true,
                  };

        const lastMonthSearchLinePercent =
            this.plan_monthly_search_records > this.last_month_search_records
                ? {
                      percent:
                          (this.last_month_search_records / this.plan_monthly_search_records) * 100,
                      exceeded: false,
                  }
                : {
                      percent:
                          (this.plan_monthly_search_records / this.last_month_search_records) * 100,
                      exceeded: true,
                  };

        let discoverArrow = null;
        let searchArrow = null;
        let lastMonthDiscoverArrow = null;
        let lastMonthSearchArrow = null;

        if (
            this.used_monthly_discover_pages >= this.plan_monthly_discover_pages &&
            this.plan_monthly_discover_pages
        ) {
            discoverArrow =
                (this.plan_monthly_discover_pages / this.used_monthly_discover_pages) * 100;
        }

        if (
            this.used_monthly_search_records >= this.plan_monthly_search_records &&
            this.plan_monthly_search_records
        ) {
            searchArrow =
                (this.plan_monthly_search_records / this.used_monthly_search_records) * 100;
        }

        if (
            this.last_month_discover_records >= this.plan_monthly_discover_pages &&
            this.plan_monthly_discover_pages
        ) {
            lastMonthDiscoverArrow =
                (this.plan_monthly_discover_pages / this.last_month_discover_records) * 100;
        }

        if (
            this.last_month_search_records >= this.plan_monthly_search_records &&
            this.plan_monthly_search_records
        ) {
            lastMonthSearchArrow =
                (this.plan_monthly_search_records / this.last_month_search_records) * 100;
        }

        const now = new Date();
        const days = now.getDate() - 2;
        const month = now.getMonth();
        const monthDaysCount = getDaysOfMonth(month);
        const discoverDailyUsage = this.used_monthly_discover_pages / (days < 1 ? 1 : days);
        const discoverMonthlyEstimation = discoverDailyUsage * monthDaysCount;

        const searchDailyUsage = this.used_monthly_search_records / (days < 1 ? 1 : days);
        const searchMonthlyEstimation = searchDailyUsage * monthDaysCount;

        const isShowSuggestion =
            this.isSuggestToChangePlan(discoverMonthlyEstimation, searchMonthlyEstimation) ||
            this.state.additionalChargesDiscover ||
            this.state.additionalChargesSearch;

        const isShowLastMonth = !!(
            this.last_month_discover_records || this.last_month_search_records
        );

        if (
            !window.user_permissions?.discover_analytics &&
            !window.user_permissions?.search_analytics &&
            !isTrue(window.is_superuser)
        )
            return null;

        return (
            <>
                <div className="additional-charges-box-header">Monthly usage</div>
                {window.user_permissions?.subscription_status === 'trialing' ? (
                    <div className="d-block card-sub-title text-muted  text-capitalize pb-20 additional-charges">
                        We do not charge any additional usage fees Within Trial Period.
                    </div>
                ) : (
                    <div
                        className="additional-charges-box"
                        style={{
                            gridTemplateColumns: isShowLastMonth ? '1fr 1fr' : '1fr',
                        }}
                    >
                        <div className="card">
                            <div className="additional-charges-trails">
                                <strong>
                                    {t('page_all_domain.monthly_usage.current_month.header')}
                                </strong>
                                <div className="progress-box">
                                    <div className="progress-box-item">
                                        <div className="progress-box-item-header">
                                            {t(
                                                'page_all_domain.monthly_usage.current_month.google_discover_pages',
                                            )}
                                        </div>
                                        <div className="progress-container">
                                            <Line
                                                percent={fisrtLinePercent.percent}
                                                // percent={1}
                                                strokeWidth={9}
                                                trailWidth={9}
                                                strokeColor="#69cdc3"
                                                strokeLinecap="square"
                                                trailColor={
                                                    fisrtLinePercent.exceeded
                                                        ? '#E00023'
                                                        : '#ECEDEF'
                                                }
                                                className="progress-bar"
                                            />
                                            {discoverArrow && (
                                                <div
                                                    className="arrow"
                                                    style={{
                                                        left: `${
                                                            discoverArrow +
                                                            calculateAddition(discoverArrow)
                                                        }%`,
                                                    }}
                                                ></div>
                                            )}
                                        </div>
                                        <div className="progress-box-item-numbers">
                                            <div className="progress-box-item-numbers-first">
                                                {numeral(this.used_monthly_discover_pages).format(
                                                    '0,0',
                                                ) ?? '-'}
                                            </div>
                                            <div className="progress-box-item-numbers-second">
                                                {t('page_all_domain.in_plan')}
                                                {numeral(this.plan_monthly_discover_pages).format(
                                                    '0,0',
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {(!this.basicPlans.includes(this.props.plan_type) ||
                                        isTrue(this.props.is_superuser)) && (
                                        <div className="progress-box-item">
                                            <div className="progress-box-item-header">
                                                {t(
                                                    'page_all_domain.monthly_usage.current_month.google_search_records',
                                                )}
                                            </div>
                                            <div className="progress-container">
                                                <Line
                                                    percent={searchLinePercent.percent}
                                                    strokeWidth={9}
                                                    trailWidth={9}
                                                    strokeColor="#69cdc3"
                                                    trailColor={
                                                        searchLinePercent.exceeded
                                                            ? '#E00023'
                                                            : '#ECEDEF'
                                                    }
                                                    strokeLinecap="square"
                                                    className="progress-bar"
                                                />
                                                {searchArrow && (
                                                    <div
                                                        className="arrow"
                                                        style={{
                                                            left: `${
                                                                searchArrow +
                                                                calculateAddition(searchArrow)
                                                            }%`,
                                                        }}
                                                    ></div>
                                                )}
                                            </div>
                                            <div className="progress-box-item-numbers">
                                                <div className="progress-box-item-numbers-first">
                                                    {' '}
                                                    {numeral(
                                                        this.used_monthly_search_records,
                                                    ).format('0,0') ?? '-'}
                                                </div>
                                                <div className="progress-box-item-numbers-second">
                                                    {t('page_all_domain.in_plan')}{' '}
                                                    {numeral(
                                                        this.plan_monthly_search_records,
                                                    ).format('0,0')}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="additional-charges-box-info">
                                {t('page_all_domain.monthly_usage.current_month.text_discover', {
                                    daily_usage: numeral(discoverDailyUsage).format('0,0'),
                                    monthly_estimation:
                                        numeral(discoverMonthlyEstimation).format('0,0'),
                                    usage_higher: this.isUsageHigher('discover')
                                        ? 'beyond plan limits, additional fees may occur'
                                        : 'within plan limits, no additional fees',
                                })}
                            </div>
                            {this.used_monthly_search_records > 0 && (
                                <div className="additional-charges-box-info">
                                    {t(
                                        'page_all_domain.monthly_usage.current_month.text_discover',
                                        {
                                            daily_usage: numeral(searchDailyUsage).format('0,0'),
                                            monthly_estimation:
                                                numeral(searchMonthlyEstimation).format('0,0'),
                                            usage_higher: this.isUsageHigher('search')
                                                ? 'beyond plan limits, additional fees may occur'
                                                : 'within plan limits, no additional fees',
                                        },
                                    )}
                                </div>
                            )}
                            {isShowSuggestion && (
                                <div className="additional-charges-box-info card-recommendation">
                                    {t('page_all_domain.monthly_usage.current_month.suggestion')}
                                    <div className=" my-3">
                                        <a
                                            className="button button-filled button-primary width-sm btn"
                                            href="/customers/change_plan/ "
                                        >
                                            {t(
                                                'page_all_domain.monthly_usage.current_month.upgrade_plan',
                                            )}
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>
                        {isShowLastMonth && (
                            <div className="card">
                                <div className="additional-charges-trails">
                                    <strong>
                                        {' '}
                                        {t('page_all_domain.monthly_usage.last_month.header')}
                                    </strong>
                                    <div className="progress-box">
                                        {!!this.last_month_discover_records && (
                                            <div className="progress-box-item">
                                                <div className="progress-box-item-header">
                                                    {t(
                                                        'page_all_domain.monthly_usage.last_month.google_discover_pages',
                                                    )}
                                                </div>
                                                <div className="progress-container">
                                                    <Line
                                                        percent={lastMonthFisrtLinePercent.percent}
                                                        strokeWidth={9}
                                                        trailWidth={9}
                                                        strokeColor="#69cdc3"
                                                        strokeLinecap="square"
                                                        trailColor={
                                                            lastMonthFisrtLinePercent.exceeded
                                                                ? '#E00023'
                                                                : '#ECEDEF'
                                                        }
                                                        className="progress-bar"
                                                    />
                                                    {lastMonthDiscoverArrow && (
                                                        <div
                                                            className="arrow"
                                                            style={{
                                                                left: `${
                                                                    lastMonthDiscoverArrow + 1.5
                                                                }%`,
                                                            }}
                                                        ></div>
                                                    )}
                                                </div>
                                                <div className="progress-box-item-numbers">
                                                    <div className="progress-box-item-numbers-first">
                                                        {numeral(
                                                            this.last_month_discover_records,
                                                        ).format('0,0') ?? '-'}
                                                    </div>
                                                    <div className="progress-box-item-numbers-second">
                                                        {t('page_all_domain.in_plan')}
                                                        {numeral(
                                                            this.plan_monthly_discover_pages,
                                                        ).format('0,0')}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {(!this.basicPlans.includes(this.props.plan_type) ||
                                            isTrue(this.props.is_superuser)) && (
                                            <div className="progress-box-item">
                                                <div className="progress-box-item-header">
                                                    {t(
                                                        'page_all_domain.monthly_usage.last_month.google_search_records',
                                                    )}
                                                </div>
                                                <div className="progress-container">
                                                    <Line
                                                        percent={lastMonthSearchLinePercent.percent}
                                                        strokeWidth={9}
                                                        trailWidth={9}
                                                        strokeColor="#69cdc3"
                                                        trailColor={
                                                            lastMonthSearchLinePercent.exceeded
                                                                ? '#E00023'
                                                                : '#ECEDEF'
                                                        }
                                                        strokeLinecap="square"
                                                        className="progress-bar"
                                                    />
                                                    {lastMonthSearchArrow && (
                                                        <div
                                                            className="arrow"
                                                            style={{
                                                                left: `${
                                                                    lastMonthSearchArrow + 1.5
                                                                }%`,
                                                            }}
                                                        ></div>
                                                    )}
                                                </div>
                                                <div className="progress-box-item-numbers">
                                                    <div className="progress-box-item-numbers-first">
                                                        {' '}
                                                        {numeral(
                                                            this.last_month_search_records,
                                                        ).format('0,0') ?? '-'}
                                                    </div>
                                                    <div className="progress-box-item-numbers-second">
                                                        {t('page_all_domain.in_plan')}
                                                        {numeral(
                                                            this.plan_monthly_search_records,
                                                        ).format('0,0')}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {this.state.additionalChargesDiscover && (
                                    <div className="additional-charges-box-info">
                                        {t(
                                            'page_all_domain.monthly_usage.last_month.text_aditional_charge',
                                            {
                                                charge: numeral(
                                                    this.state.additionalChargesDiscover?.charge,
                                                ).format('0,0'),
                                                additional_pages: numeral(
                                                    this.state.additionalChargesDiscover
                                                        ?.additional_pages,
                                                ).format('0,0'),
                                            },
                                        )}
                                    </div>
                                )}
                                {this.state.additionalChargesSearch && (
                                    <div className="additional-charges-box-info">
                                        {t(
                                            'page_all_domain.monthly_usage.last_month.text_aditional_charge_search',
                                            {
                                                charge: numeral(
                                                    this.state.additionalChargesSearch?.charge,
                                                ).format('0,0'),
                                                additional_pages: numeral(
                                                    this.state.additionalChargesSearch
                                                        ?.additional_pages,
                                                ).format('0,0'),
                                            },
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </>
        );
    }
}

export default withTranslation()(AdditionalCharges);
